<template>
    <div v-if="params && params.isActive">
        <ModalDefault @close="close()" :loading="loading">
            <template slot="main">
                <p class="modal-title">{{ params.zone.name }} - {{ currentBrand.name }}</p>
                <div class="mb-4">
                    <p class="label-relation-type mb-1">
                        {{ $t("zone.relationBetween", { zone: params.zone.name.toUpperCase(), brand: currentBrand.name.toUpperCase() }) }}
                    </p>
                    <p class="red mb-3">
                        {{ $t("zone.editWarning") }}
                    </p>
                    <Multiselect
                        v-model="selectedZoneRelationType"
                        :options="zoneRelationTypes"
                        label="name"
                        track-by="name"
                        :multiple="false"
                        :select-label="''"
                        :custom-label="nameZoneBrand"
                        :searchable="false"
                        :close-on-select="true"
                        :show-labels="true"
                        :placeholder="'select zone type'"
                        :hide-selected="true"
                    ></Multiselect>
                </div>

                <label for="allowCatalogForecast" class="row label-checkbox pointer d-flex align-items-center">
                    <div class="col">
                        <span class="label-title label-allow-forecast">{{ $t("zone.allowCatalogForecast") }}</span>
                    </div>
                    <div class="col">
                        <span v-show="cfAllowForecast" class="rem3rch-checkbox rem3rch-checkbox-xs"> <i class="fa fa-check"></i> </span>
                        <span v-if="!cfAllowForecast" class="rem3rch-checkbox rem3rch-checkbox-xs"></span>
                    </div>
                    <input id="allowCatalogForecast" type="checkbox" class="d-none" v-model="cfAllowForecast" />
                </label>

                <label for="allowCatalogFirmOrder" class="row label-checkbox pointer d-flex align-items-center">
                    <div class="col">
                        <span class="label-title label-allow-firmorder">{{ $t("zone.allowCatalogFirmOrder") }}</span>
                    </div>
                    <div class="col">
                        <span v-show="cfAllowFirmorder" class="rem3rch-checkbox rem3rch-checkbox-xs"> <i class="fa fa-check"></i> </span>
                        <span v-if="!cfAllowFirmorder" class="rem3rch-checkbox rem3rch-checkbox-xs"></span>
                    </div>
                    <input id="allowCatalogFirmOrder" type="checkbox" class="d-none" v-model="cfAllowFirmorder" />
                </label>

                <div class="d-flex justify-content-end mt-4">
                    <ClientColorButton
                        :inactiveColor="!isValidateForm"
                        :background-color="currentBrand.linksColor"
                        @click="saveBrandZone()"
                        class="mr-3"
                        :disabled="!isValidateForm"
                        >{{ $trad.common.save }}</ClientColorButton
                    >
                    <ClientColorButton :inactiveColor="true" @click.prevent="close()">{{ $trad.common.cancel }}</ClientColorButton>
                </div>
            </template>
        </ModalDefault>
    </div>
</template>

<script>
import { mapState } from "vuex";
import ModalTheme from "@/components/ui/ModalTheme";
import TextInputBloc from "@/components/ui/Form/TextInputBloc";
import TryLoad from "@/mixins/TryLoadMixin";
import zoneService from "@/services/zone";
import Multiselect from "vue-multiselect";
import brandService from "@/services/brand";
import historyService from "@/services/history";
import { OBJECT_TYPE, SHORT_DESCRIPTION } from "@/components/history/constants";
import ModalDefault from "@/components/ui/ModalDefault";

export default {
    data() {
        return {
            loading: false,
            zoneRelationTypes: [],
            selectedZoneRelationType: null,
            cfAllowForecast: false,
            cfAllowFirmorder: false
        };
    },
    components: {
        ModalDefault,
        ModalTheme,
        TextInputBloc,
        Multiselect
    },
    props: {
        params: {
            type: Object,
            required: true
        }
    },
    watch: {},
    mixins: [TryLoad],
    mounted() {},
    methods: {
        close() {
            this.params.isActive = false;
            this.$emit("close");
        },
        saveBrandZone() {
            try {
                const requestBody = {
                    relationTypeId: this.selectedZoneRelationType.id,
                    cfAllowFirmorder: this.cfAllowFirmorder,
                    cfAllowForecast: this.cfAllowForecast
                };

                this.tryLoad(() => zoneService.updateBrandZoneParameters(this.params.brandZone.id, requestBody))
                    .then(() => {
                        this.dialogSuccess(SHORT_DESCRIPTION.ZONE_TYPE_UPDATED);
                        this.$emit("success");
                        this.close();
                    })
                    .catch(() => this.dialogError("error"));
            } catch (e) {
                this.dialogError("error");
            }
        },
        nameZoneBrand(zoneRelationType) {
            return zoneRelationType.name.toUpperCase();
        }
    },
    computed: {
        ...mapState("currentUser", ["currentBrand"]),
        isValidateForm() {
            return this.selectedZoneRelationType;
        }
    },
    async created() {
        this.loading = true;
        this.zoneRelationTypes = await brandService.getZoneRelationType();
        this.selectedZoneRelationType = this.zoneRelationTypes.find(zrt => zrt.id === this.params.brandZone.zoneRelationType.id);
        this.cfAllowFirmorder = this.params.brandZone.cfAllowFirmorder;
        this.cfAllowForecast = this.params.brandZone.cfAllowForecast;
        this.loading = false;
    }
};
</script>
<style lang="scss" scoped>
.label-relation-type,
.label-allow-forecast,
.label-allow-firmorder {
    font-family: "oswald", Sans-Serif;
    font-size: 18px !important;
    font-weight: bold;
    text-transform: initial;
}

p.red {
    color: red;
}
</style>



// WEBPACK FOOTER //
// EditZoneParams.vue?6eaedc24